import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { VoidStatementModalContent } from './content';
export default function VoidStatementModal(_ref) {
  let disabled = _ref.disabled,
    id = _ref.id,
    setTriggerRefresh = _ref.setTriggerRefresh,
    variant = _ref.variant;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    variant: variant || 'action',
    'custom-attribute': '818-resident-profile-page-VoidStatementModal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "minus-circle"
  }), t("resident_account.process_void"));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    disabledTrigger: disabled,
    trigger: defaultTrigger,
    title: t('resident_account.void_statement'),
    noPadding: true,
    noFooter: true
  }, /*#__PURE__*/React.createElement(VoidStatementModalContent, {
    id: id,
    setTriggerRefresh: setTriggerRefresh
  }));
}